import * as ActionTypes from '../actions/index';
import _ from 'lodash';

const defaultState = {
    brokers: [],
    fetching: false,
    selectedBrokers: {}, // brokerId: broker,
    allBrokersSelected: false,
    action: '',
    viewAmount: 20,
    totalPaginationBoxes: 0,
    page: 1,
    totalRecords: 0,
    suggestions: [],
    suggestionFieldValue: '',
    fetchingSuggestions: false,
    filterByBroker: '',
    sortBy: 'name',
    sortOrder: 'ASC'
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case ActionTypes.UPDATE_BROKER_BY_ID_SUCCESS:
            let brokerIndex = _.findIndex(state.brokers, broker => {return broker.id === action.payload.body.id});
            let updatedBrokers  = [...state.brokers];
            if(brokerIndex > -1){
                updatedBrokers[brokerIndex]['status'] = action.payload.body.status;
            }
            return {
                ...state,
                brokers: updatedBrokers
            };
        case ActionTypes.SORT_BROKERS:
            return {
                ...state,
                sortBy : action.payload.sortBy,
                sortOrder: action.payload.sortOrder,
                selectedBrokers: {},
                allBrokersSelected: false
            };
        case ActionTypes.GET_BROKERS_SUGGESTIONS:
            return {
                ...state,
                fetchingSuggestions: true
            };
        case ActionTypes.GET_BROKERS_SUGGESTIONS_SUCCESS:
            return {
                ...state,
                suggestions: action.payload.body.data,
                fetchingSuggestions: false
            };
        case ActionTypes.GET_BROKERS_SUGGESTIONS_FAILED:
            return {
                ...state,
                fetchingSuggestions: false
            };
        case ActionTypes.CHANGE_BROKERS_LIST_PAGE:
            return {
                ...state,
                page: action.payload.value,
                selectedBrokers: defaultState.selectedBrokers,
                allBrokersSelected: defaultState.allBrokersSelected
            };
        case ActionTypes.BROKERS_LIST_PAGE_SHIFT:
            if (action.payload === 'left' && state.page > 1) {
                return {
                    ...state,
                    page: state.page - 1,
                    selectedBrokers: {},
                    allBrokersSelected: false
                }
            }
            else if (action.payload === 'right' && state.page < state.totalPaginationBoxes) {
                return {
                    ...state,
                    page: state.page + 1,
                    selectedBrokers: {},
                    allBrokersSelected: false
                }
            }
            else {
                return state
            }
        case ActionTypes.CHANGE_BROKERS_STATE:
            return {
                ...state,
                [action.payload.key]: action.payload.value
            };
        case ActionTypes.GET_BROKERS:
            return {
                ...state,
                fetching: true
            };
        case ActionTypes.GET_BROKERS_SUCCESS:
            let totalDisplayBoxes = Math.ceil(action.payload.body.totalRecords / parseInt(state.viewAmount));
            let currentPage = parseInt(state.page);
            if(currentPage > totalDisplayBoxes && totalDisplayBoxes !== 0){
                currentPage = totalDisplayBoxes;
            }
            return {
                ...state,
                fetching: false,
                brokers: action.payload.body.data,
                totalRecords: action.payload.body.totalRecords,
                page: currentPage,
                totalPaginationBoxes: totalDisplayBoxes
            };
        case ActionTypes.GET_BROKERS_FAILED:
            return {
                ...state,
                fetching: false
            };
        case ActionTypes.LOGOUT:
            return {
                ...defaultState
            };
        default:
            return state
    }
}